import { render, staticRenderFns } from "./PointsExchangeTradePage.vue?vue&type=template&id=0c97a9a1&scoped=true"
import script from "./PointsExchangeTradePage.vue?vue&type=script&lang=js"
export * from "./PointsExchangeTradePage.vue?vue&type=script&lang=js"
import style0 from "./PointsExchangeTradePage.vue?vue&type=style&index=0&id=0c97a9a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c97a9a1",
  null
  
)

export default component.exports